<template>
	<span class="block text-xs text-error"><slot /></span>
</template>
